angular
  .module('contrast.factory.report', [])
  .factory('ReportFactory', function ($http, UserService) {
    return {
      getReportSettings: function () {
        return $http.get(UserService.buildAPIUrl('/report/settings'))
      },
      saveReportSettings: function (settings) {
        return $http.put(UserService.buildAPIUrl('/report/settings'), settings)
      }
    }
  })
